import React, { useEffect, useRef, useState } from "react";
import Numpad from "../NumPad/NumPad";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import {
  ListProviderGiftCards,
  ListticketType,
} from "../../../_App/Data/GiftCards";
import CalculatorQte from "./CalculatorQte";
import { handleKeyPress } from "../../../_App/Helpers/helpers";

const GiftCardPaymentMethod = ({
  total,
  enteredAmountGiftCard,
  onAmountChange,
  setListGiftcard,
  ListGiftcard,
}: any) => {
  const [givenAmountGiftCard, setGivenAmountGiftCard] = useState<string | null>(
    null
  );
  const [Input, setInput] = useState(1);
  const [OpenCalculator, setOpenCalculator] = useState(false);
  const [ScanCode, setScanCode] = useState("");
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();

  const scanInputRef = useRef<HTMLInputElement>(null); // ✅ ref pour l’input Scan

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const amount: any = e.target.value === "" ? 0 : e.target.value;
    setGivenAmountGiftCard(isNaN(amount) ? null : amount);
    onAmountChange(isNaN(amount) ? null : amount);
  };

  useEffect(() => {
    setGivenAmountGiftCard(null);
  }, [total]);

  const focusScanInput = () => {
    setTimeout(() => {
      scanInputRef.current?.focus();
    }, 100);
  };

  const ScanFunction = (value: string) => {
    if (value.length < 11) {
      ToastWarning("Code-barres invalide ou trop court.");
      focusScanInput();
      return;
    }

    const providerCode = value.substring(0, 2);
    const typeCode = value.substring(2, 4);
    const amountCode = value.substring(4, 9);
    const year = `20${value.substring(9, 11)}`;

    if (parseInt(year) < new Date().getFullYear()) {
      ToastWarning(`Ticket expirée l 'année ${year}`);
      setGivenAmountGiftCard("");
      setScanCode("");
      focusScanInput();
      return;
    }

    let providerObj = ListProviderGiftCards.find(
      (a) => a.code === providerCode
    );
    let provider = providerObj?.name || "Inconnu";
    let taux = providerObj?.taux || 10;
    let ticketType =
      ListticketType.find((a) => a.code === typeCode)?.name || "Type inconnu";

    const amountcard = (parseInt(amountCode, 10) / 1000).toFixed(3);
    const amount =
      parseFloat(amountcard) - parseFloat(amountcard) * (taux / 100);

    const findelementIndex = ListGiftcard.findIndex(
      (a: any) =>
        a.provider === provider &&
        a.typecard === ticketType &&
        a.amountInitiale === amount
    );

    let copie = [...ListGiftcard];
    if (findelementIndex === -1) {
      copie = [
        ...copie,
        {
          provider,
          typecard: ticketType,
          amountCard: amountcard,
          amount,
          amountInitiale: amount,
          qte: Input,
        },
      ];
    } else {
      copie[findelementIndex].amount = Number(
        (copie[findelementIndex].amount + amount).toFixed(3)
      );
      copie[findelementIndex].qte += Input;
    }

    setListGiftcard(copie);

    const totalAmount = copie.reduce(
      (acc: any, cur: any) => acc + parseFloat(cur.amount) || 0,
      0
    );

    onAmountChange(totalAmount);
    setScanCode("");
    setInput(1);
    focusScanInput(); // ✅ Re-focus après scan
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastKeyPressTime = useRef<number>(0);

  const ScanCodeGiftCard = (e: any) => {
    const value = e.target.value;
    const cleanedValue = value.replace(/[\r\n\t]+/g, "").trim();
    setScanCode(cleanedValue);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;
    const isScannerInput = timeDiff < 50;

    if (timeoutId) clearTimeout(timeoutId);
    const newTimeoutId = setTimeout(
      async () => {
        if (cleanedValue !== "") {
          ScanFunction(cleanedValue );
        }
      },
      isScannerInput ? 100 : 3000
    );
    setTimeoutId(newTimeoutId);
  };

  const removeLigne = (index: number) => {
    const copie = [...ListGiftcard];
    copie.splice(index, 1);
    setListGiftcard(copie);

    const totalAmount = copie.reduce(
      (acc: number, cur: any) => acc + (parseFloat(cur.amount) || 0),
      0
    );

    onAmountChange(totalAmount);
    focusScanInput(); // ✅ re-focus après suppression
  };

  const onChange = (index: any, action: any) => {
    const copie = [...ListGiftcard];
    if (action === "plus") {
      copie[index].qte += 1;
      copie[index].amount = Number(
        (copie[index].amount + parseFloat(copie[index].amountInitiale)).toFixed(
          3
        )
      );
    } else {
      const newQte = copie[index].qte - 1;
      if (newQte <= 0) {
        removeLigne(index);
        return;
      } else {
        copie[index].qte = newQte;
        copie[index].amount = Number(
          (
            copie[index].amount - parseFloat(copie[index].amountInitiale)
          ).toFixed(3)
        );
      }
    }

    const totalAmount = copie.reduce(
      (acc: any, cur: any) => acc + parseFloat(cur.amount) || 0,
      0
    );

    onAmountChange(totalAmount);
    setListGiftcard(copie);
    focusScanInput(); // ✅ re-focus après + ou -
  };

  useEffect(() => {
    if (!OpenCalculator) focusScanInput(); // ✅ quand on ferme le calculateur
  }, [OpenCalculator]);

  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form className="form-inline search-full form-inline search" role="search">
            <div
              className="search-bar d-flex align-items-center"
              style={{ marginBottom: "7px", gap: "10px" }}
            >
              <input
                ref={scanInputRef} // ✅ référence ici
                type="text"
                className="form-control search-form-control ml-lg-auto"
                placeholder="Scan"
                onChange={ScanCodeGiftCard}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onKeyPress={handleKeyPress}
                value={ScanCode}
                autoFocus
                style={{ flex: 1 }}
              />

              <i
                onClick={() => setOpenCalculator(true)}
                className="fas fa-calculator fa-lg"
              ></i>

              <span
                className="d-flex flex-column justify-content-center align-items-center"
                onClick={() => setOpenCalculator(true)}
                style={{
                  width: "80px",
                  fontSize: "26px",
                  cursor: "pointer",
                  color: "white",
                }}
              >
                {Input}
              </span>
            </div>

            {ListGiftcard &&
              ListGiftcard.map((i: any, index: number) => (
                <div className="row mt-3" key={index}>
                  <div
                    className="search-bar col-1 pointer"
                    style={{ marginBottom: "7px" }}
                    onClick={() => removeLigne(index)}
                  >
                    <i className="fas fa-trash-alt fa-lg"></i>
                  </div>

                  <div className="search-bar col-5" style={{ marginBottom: "7px" }}>
                    <input
                      type="text"
                      className="form-control search-form-control"
                      placeholder="provider"
                      value={i.provider}
                      disabled
                    />
                  </div>

                  <div className="search-bar col-6" style={{ marginBottom: "7px" }}>
                    <input
                      type="text"
                      className="form-control search-form-control"
                      placeholder="typecard"
                      value={i.typecard}
                      disabled
                    />
                  </div>

                  <div
                    className="search-bar col-1"
                    style={{ marginBottom: "7px" }}
                    onClick={() => onChange(index, "minus")}
                  >
                    <i className="fas fa-window-minimize fa-lg"></i>
                  </div>

                  <div
                    className="search-bar col-1"
                    style={{ fontWeight: "bolder", fontSize: "20px" }}
                  >
                    {i.qte}
                  </div>

                  <div
                    className="search-bar col-1"
                    style={{ marginBottom: "7px" }}
                    onClick={() => onChange(index, "plus")}
                  >
                    <i className="fas fa-plus fa-lg"></i>
                  </div>

                  <div className="search-bar col-3" style={{ marginBottom: "7px" }}>
                    <input
                      type="text"
                      className="form-control search-form-control ml-lg-auto"
                      placeholder="Montant ticket"
                      value={i.amountCard}
                      disabled
                    />
                  </div>

                  <div className="search-bar col-3" style={{ marginBottom: "7px" }}>
                    <input
                      type="text"
                      className="form-control search-form-control ml-lg-auto"
                      placeholder="Montant initial"
                      value={i.amountInitiale}
                      disabled
                    />
                  </div>

                  <div className="search-bar col-3" style={{ marginBottom: "7px" }}>
                    <input
                      type="text"
                      className="form-control search-form-control ml-lg-auto"
                      placeholder="Montant total"
                      value={i.amount}
                      disabled
                    />
                  </div>
                </div>
              ))}
          </form>
        </div>

        {OpenCalculator && (
          <CalculatorQte
            ShowModal={OpenCalculator}
            setShowModal={setOpenCalculator}
            Qteinput={Input}
            setQte={setInput}
          />
        )}
      </div>
    </div>
  );
};

export default GiftCardPaymentMethod;
